import { api } from '../utils/apiClient';

export const adminUserService = {
  async list() {
    return api.get('/admin-users');
  },

  // Returns { admin, temporary_password } — the plaintext password is only
  // ever present in this one response, never retrievable again.
  async create({ email, name }) {
    return api.post('/admin-users', { email, name });
  },

  async remove(id) {
    return api.del('/admin-users/' + id);
  },
};
